<template>
    <div v-if="activations.length">
		<div class="bonus__item" v-for="(activation) in activations">
			<div class="bonus__item-main">
				<svg class="bonus__item-icon"><use href="#svg-icon-mines-gift"></use></svg>
				<div class="bonus__item-content">
					<div class="bonus__item-title">{{ activation.promocode.amount_title }}</div>
				</div>
				<button @click="activate(activation.id)" class="bonus__item-action">
					Активировать
				</button>
			</div>
			<div class="bonus__hr"></div>
			<div class="bonus__check-items">
				<TypeBalance v-if="activation.promocode.type === 'balance'" :activation="activation" />

				<TypeBalance v-if="activation.promocode.type === 'balance_referrer'" :activation="activation" />

				<TypeDeposit v-if="activation.promocode.type === 'deposit'" :activation="activation" />

				<TypeDeposit v-if="activation.promocode.type === 'deposit_referrer'" :activation="activation" />

				<TypeFreespin v-if="activation.promocode.type === 'freespin'" :activation="activation" />
			</div>
			<div class="bonus__check-item text-muted">
				Можно активировать до: {{ $root.moment(activation.created_at).add(24, 'hours').format('YYYY-MM-DD, HH:mm') }}
			</div>

		</div>
    </div>
</template>

<script>
    import TypeBalance from './types/PromoBalance.vue';
    import TypeDeposit from './types/PromoDeposit.vue';
    import TypeFreespin from './types/PromoFreespin.vue';

    export default {
        components: {
            TypeBalance,
            TypeDeposit,
            TypeFreespin
        },
        data() {
            return {
                activations: []
            }
        },
        mounted() {
            this.get();
        },
        created() {
			this.$root.emitter.on('promocode.activated', this.get);
        },
        destroyed() {
			this.$root.emitter.off('promocode.activated', this.get);
        },
        methods: {
            activate(id) {
                this.$root.axios.post('/api/promocode/activations/activate', {
                    'id': id
                })
                .then(res => {
                    this.$toast.success(res.data.message);

                    this.get();
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            get() {
                this.$root.axios.get('/api/promocode/activations')
                .then(res => {
                    this.activations = res.data.activations;
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            }
        }
    }
</script>